import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modals_action.data.affiliate_signup,
    props.user.user,
    (data, user) => {
        return {
            ...data[data.stage],
            user
        };
    }
)